<div class="row pb-5">
  <div class="col-md-12 order-2 order-md-1" [hidden]="!hasTeamsCallSettingsFieldsToShow()">
    <ziro-fieldset-header [forceShowLegend]="true" [legend]="'tkey;shared.model.microsoft_teams_calling.settings.text'">
      <ziro-teams-call-queues-form [upn]="upn()" [tenantId]="tenantId()"></ziro-teams-call-queues-form>
      <ziro-select [fieldId]="'callingPolicy'"></ziro-select>
      <ziro-select [fieldId]="'teamsCallHoldPolicy'"></ziro-select>
      <ziro-select [fieldId]="'teamsCallParkPolicy'"></ziro-select>
      <ziro-select [fieldId]="'callingLineIdentity'"></ziro-select>
      <ziro-select [fieldId]="'tenantDialPlan'"></ziro-select>
      <ziro-select [fieldId]="'emergencyCallingPolicy'"></ziro-select>
      <ziro-select [fieldId]="'emergencyCallRoutingPolicy'"></ziro-select>
      <ziro-select [fieldId]="'onlineVoiceRoutingPolicy'"></ziro-select>
      <ziro-select [fieldId]="'onlineVoicemailPolicy'"></ziro-select>
      <ziro-select [fieldId]="'ipPhonePolicy'"></ziro-select>
      <ziro-select [fieldId]="'emergencyLocation'"></ziro-select>
      <ziro-text [fieldId]="'lineUriExtension'"></ziro-text>
    </ziro-fieldset-header>
  </div>

  @if (!!bandwidthFieldConfig()) {
    <div class="col-md-12 order-2 order-md-1">
      <ziro-bandwidth-emergency-calling-form
        [bandwidthFieldConfig]="bandwidthFieldConfig()"
        [bandwidthEntity]="bandwidthEntity()"
        [teamsLine]="teamsLine()"
      ></ziro-bandwidth-emergency-calling-form>
    </div>
  }
  @if (isAdWriteDownConfigured() && !!onPremUpn()) {
    <div class="col-md-12 order-2 order-md-1" [attr.data-automation]="'helpdesk-ad-attributes'">
      <ziro-helpdesk-ad-attributes
        [isZpcSyncWarningPresent]="isZpcSyncWarningPresent()"
        [tenantId]="tenantId()"
        [onPremUpn]="onPremUpn()"
        [selectedNumber]="lineUri()"
        [mainNumber]="mainNumber()"
        [lineUriExtensionForDedicatedDid]="lineUriExtensionForDedicatedDid"
        [dialPlanId]="dialPlanFieldConfig().id"
      ></ziro-helpdesk-ad-attributes>
    </div>
  }
  @if (isEntraWriteDownConfigured() && !onPremUpn()) {
    <div class="col-md-12 order-2 order-md-1" [attr.data-automation]="'helpdesk-entra-attributes'">
      <ziro-helpdesk-entra-attributes
        [tenantId]="tenantId()"
        [upn]="upn()"
        [selectedNumber]="lineUri()"
        [mainNumber]="mainNumber()"
        [lineUriExtensionForDedicatedDid]="lineUriExtensionForDedicatedDid"
        [dialPlanId]="dialPlanFieldConfig().id"
        [isExistingTeamsCalling]="isExistingTeamsCalling"
      ></ziro-helpdesk-entra-attributes>
    </div>
  }
</div>
